import { render, staticRenderFns } from "./EditVoteSetting.vue?vue&type=template&id=5085093d"
import script from "./EditVoteSetting.vue?vue&type=script&lang=js"
export * from "./EditVoteSetting.vue?vue&type=script&lang=js"
import style0 from "./EditVoteSetting.vue?vue&type=style&index=0&id=5085093d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports